import {Component, HostListener, input, output} from '@angular/core';


@Component({
  selector: 'app-notification-panel-toggle',
  imports: [],
  template: `
    <div
      class="notification-toggle"
      [class.opened]="opened()"
      (click)="togglePanel()">
      <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5 14.873C15.1993 14.873 17.3734 14.2702 17.5833 11.8504C17.5833 9.43232 16.0676 9.58782 16.0676 6.62092C16.0676 4.30344 13.871 1.66666 10.5 1.66666C7.12897 1.66666 4.93236 4.30344 4.93236 6.62092C4.93236 9.58782 3.41666 9.43232 3.41666 11.8504C3.62745 14.2793 5.80147 14.873 10.5 14.873Z" stroke="#AFBACA" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12.4906 17.381C11.3539 18.6432 9.58052 18.6582 8.43286 17.381" stroke="#AFBACA" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      @if (count() > 0) {
        <span class="notification-badge">{{ count() }}</span>
      }
    </div>
  `,
  styles: `
    .notification-toggle {
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      position: relative;
      width: 40px;
      height: 40px;
      transition: background-color 0.3s ease;
    }

    .notification-toggle.opened {
      background-color: #e0e0e0;
    }

    .notification-badge {
      position: absolute;
      top: 0;
      right: 0;
      min-width: 16px;
      height: 16px;
      padding: 0 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 10px;
      font-weight: bold;
      color: white;
      border-radius: var(--corner-radius-Full-round, 624.9375rem);
      background: #E32D2D;
    }
  `
})
export class NotificationPanelToggleComponent {
  /**
   * The number of unread notifications to display
   */
  count = input<number>(0);

  /**
   * Whether the notification panel is currently open
   */
  opened = input<boolean>(false);

  /**
   * Event emitted when the toggle is clicked, with the new opened state
   */
  openedChange = output<boolean>();

  /**
   * Toggles the panel open/closed state and emits the new state
   */
  @HostListener('click')
  togglePanel(): void {
    const newOpenedState = !this.opened();
    this.openedChange.emit(newOpenedState);
  }

}
